import { render, staticRenderFns } from "./DeployPackageRoot.vue?vue&type=template&id=60785f53"
import script from "./DeployPackageRoot.vue?vue&type=script&lang=ts"
export * from "./DeployPackageRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports